<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				// {
				// 	"type": "$input",
				// 	"field": "nickName",
				// 	"title": "昵称",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {
				// 		"readonly": false
				// 	},
				// 	"validate": [{
				// 		"required": true,
				// 		"message": "必填项"
				// 	}]
				// },
				{
					"type": "$inputButton",
					"field": "content",
					"title": "智能识别",
					"value": null,
					"hidden": false,
					"props": {

					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "nickName",
					"title": "昵称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "unitName",
					"title": "客户名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "cellphone",
					"title": "手机",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": true,
						"message": "【手机】请以数字开头和结尾，特殊字符支持#-"
					}]
				},
				{
					"type": "$select",
					"field": "citystreet",
					"title": "省市区街道",
					"value": null,
					"hidden": false,
					"props": {
						"cascader": true,
						"checkStrictly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "addr",
					"title": "详细地址",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "phone",
					"title": "固话",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "【固话】请以数字开头和结尾，特殊字符支持+-"
					}]
				},
				{
					"type": "$input",
					"field": "zip",
					"title": "邮编",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "【邮编】只支持6位数字",

					}]
				},
				{
					"type": "$input",
					"field": "email",
					"title": "邮箱",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "【邮箱】E-mail格式不正确"
					}]
				},
				{
					"type": "$input",
					"field": "remark",
					"title": "备注",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '客户信息',
				modal_width: 800,
				modal_height: 500,
				loading: false,
				force: 0,
				initCity: []
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.loading = true
				if(!this.initCity.length){
					this.$api.crmcustomer.initCity().then((res) => {
						this.initCity = res
						this.modal_init_handle()
						this.$emit('show')
						this.loading = false
					}, () => {
						this.loading = false
					})
				}else{
					this.modal_init_handle()
					this.loading = false
				}


			},
			modal_init_handle(){
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				rule.forEach((item) => {
					if (item.field == 'citystreet') {
						item.options = this.initCity
					}
					if (item.field == 'zip') {
						item.validate[0].pattern = /^\d{6}$/
					}
					if (item.field == 'email') {
						item.validate[0].pattern = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/
					}
					if (item.field == 'phone') {
						item.validate[0].pattern = /^\d[+\-\d]*\d$|^\d$/
					}
					if (item.field == 'cellphone') {
						item.validate[0].pattern = /^\d[#\-\d]*\d$|^\d$/
					}
				})
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
				})
			},
			
			
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			contentButton() {
				let content = this.fApi.getValue('content')
				if (!content) {
					this.$message.error('请输入内容')
					return
				}
				this.loading = true
				this.$api.crmcustomer.regionmatch({
					content: content
				}).then((res) => {
					this.loading = false
					let citystreet = []
					if(res.provinceName){
						citystreet.push(res.provinceName)
					}
					if(res.cityName){
						citystreet.push(res.cityName)
					}
					if(res.districtName){
						citystreet.push(res.districtName)
					}
					if(res.townName){
						citystreet.push(res.townName)
					}
					this.fApi.setValue('citystreet',citystreet)
					this.fApi.setValue('cellphone',res.cellphone)
					this.fApi.setValue('addr',res.detail)
					console.log(res)
				},()=>{
					this.loading = false
				})
			},



			setFormData() {
				if (this.sourceData) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					let citystreet = submitData.citystreet ? submitData.citystreet : []
					submitData.province = citystreet[0] ? citystreet[0] : ""
					submitData.city = citystreet[1] ? citystreet[1] : ""
					submitData.area = citystreet[2] ? citystreet[2] : ""
					submitData.town = citystreet[3] ? citystreet[3] : ""

					let custom = {
						addr: "",
						area: "",
						balance: 0,
						cellphone: "",
						city: "",
						customType: 0,
						// debtCredit: 10000,
						discount: 0,
						email: "",
						initial: 0,
						initialSettle: 0,
						nickName: "",
						nickType: -1,
						phone: "",
						province: "",
						receiveBalance: 0,
						receiveIncrease: 0,
						rechargeBalance: 0,
						remark: "",
						town: "",
						unitName: "",
						zip: "",
					}
					for (let i in custom) {
						if (submitData[i]) {
							custom[i] = submitData[i]
						}
					}

					console.log(custom)
					// return
					// this.submitDataFormater(submitData)
					this.loading = true
					this.$api.crmcustomer.saveerpcustomer({
						custom: custom,
						force: this.force
					}).then((res) => {
						this.loading = false
						if (res) {
							this.$confirm(custom.cellphone + '手机号已关联客户，请勿重复添加。', '提示', {
								confirmButtonText: '强制添加',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.loading = true
								this.force = 1
								this.submit()
							}).catch(() => {
								this.force = 0
								this.loading = false
							})
						} else {
							this.$message.success('添加成功')
							this.force = 0
							this.$emit('success')
							this.modal_cancel()
						}
					}, () => {
						this.loading = false
					})

				}, (fApi) => {
					fApi.validate((valid, errors) => {
						if (!valid) {
							let arr = []
							for (let i in errors) {
								errors[i].forEach((item) => {
									arr.push(item.message)
								})
							}
							if (arr.length) {
								this.$message.error(arr[0])
							}
						}
					})
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>